<script>
import { mapState } from 'vuex';
export default {
  name: 'RouteView',
  props: {
    keepAlive: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      keepAliveInclude: state => state.multTabStore.keepAliveInclude
    })
  },
  render () {
    const { $route: { meta } } = this;
    const inKeep = (
      <keep-alive include={this.keepAliveInclude}>
        <router-view />
      </keep-alive>
    )
    const notKeep = (
      <router-view />
    )

    if (meta.unkeep) {
      return notKeep
    }
    return this.keepAlive ? inKeep : notKeep
  }
}
</script>

<style scoped>
</style>